import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'date_made',
    width: '7%',
  },
  {
    data: 'donation_amount',
    width: '50%',
  },
  {
    data: 'payment_method',
    width: '15%',
  },
  {
    data: 'source',
    width: '30%',
  },
  {
    data: 'regular_donation',
    width: '5%',
    className: 'light',
    searchable: false,
    orderable: false,
  },
  {
    data: 'regular_donation_start_date',
    width: '7%',
    searchable: false,
    orderable: false,
  },
  {
    data: 'regular_donation_end_date',
    width: '7%',
    searchable: false,
    orderable: false,
  },
  {
    data: 'regular_donation_status',
    width: '7%',
    searchable: false,
    orderable: false,
    render: function(data, type, row, meta) {
      const getStatusClass = () => {
        if (data && data.toLowerCase() === 'active') {
          return 'accent'
        }
        return 'blue-100'
      }

      return `<span class="bold ${getStatusClass()} capitalize">${data || ''}</span>`
    },
  },
  {
    data: 'id',
    className: 'right',
    sortable: false,
    render: (data, type, row) => {
      return row.manualEntry === 'true'
        ? renderToString(
            <div style={{ position: 'relative', height: '20px', width: '20px' }}>
              <button
                data-donation-id={data}
                className="delete-donation"
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', position: 'absolute', top: '0', right: '0' }}
              >
                <SvgIconsDelete style={{ pointerEvents: 'none' }} />
              </button>
            </div>
          )
        : ''
    },
  },
]

const headers = ['Date Made', 'Donation Amount', 'Payment Method', 'Source', 'Recurring', 'Start Date', 'End Date', 'Status', '']

const filters = []

const sorters = [
  { column: 0, label: 'Date Made', order: 'desc' },
  { column: 1, label: 'Donation Amount', order: 'desc' },
]

const order = [[ 0, "desc" ]]

export { columns, headers, filters, sorters, order }
